// import Swiper bundle with all modules installed
import { data } from 'jquery';
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

const SwiperGalleries = function () {


    //galeria areas comuns
    const galleryAreas = () => {

        const galAreas = ".swiper-areas";
        if ($(galAreas).length <= 0) return;

        // for( let i=0; i< $(galAreas).length; i++ ) {
        $(galAreas).each(function (e) {

            let _parent = $(galAreas).eq(e).closest('.row-gallery');

            $(galAreas).eq(e).addClass('swiper-container-areas-' + e);
            _parent.find('.swiper-button-prev').addClass('swiper-button-prev-areas-' + e);
            _parent.find('.swiper-button-next').addClass('swiper-button-next-areas-' + e);
            _parent.find('.swiper-pagination').addClass('swiper-pagination-areas-' + e);

            /* if($('.swiper-container-areas-' + e).find('picture').length <= 1) {
                $('.swiper-container-areas-' + e).closest('.row-gallery').find('.wrap-navigation-sw').hide();
            } */

            const swiperareas = new Swiper('.swiper-container-areas-' + e, {
                // cssMode     : true,
                speed: 1500,
                loop: true,
                effect: 'slide',
                // slidesPerView: 1.4,
                slidesPerView: 1,
                spaceBetween: '10px',
                centeredSlides: true,
                autoplay: false,
                pagination: {
                    el: screen.width > 992 ? '.swiper-pagination-areas-' + e : '#pag-ares',
                    type: screen.width > 992 ? 'custom' : '',
                    renderCustom: function (swiper, current, total) {
                        return '<span class="swiper-pagination-current-custom"> <strong class="me-1">' + current + ' </strong> </span> | ' + total;
                    }
                    /* clickable: true,
                    renderBullet: function (areas, className) {
                    return '<span class="' + className + '">' + (areas + 1) + "</span>";
                    }, */
                },
                navigation: {
                    prevEl: '.swiper-button-prev-areas-' + e,
                    nextEl: '.swiper-button-next-areas-' + e,
                },
                breakpoints: {
                    768: {
                        slidesPerView: "auto",
                        spaceBetween: '8%',
                        centeredSlides: true,
                    }
                }
            });
            swiperareas.on('slideChangeTransitionEnd', function (sw) {
                // console.log(swiperareas.activeIndex, sw);
                let imgZoom = $(galAreas).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-zoom');
                let textDinamic = $(galAreas).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-to-text');
                let titleDinamic = $(galAreas).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-to-title');

                // ativa menu de nav
                const galTypeCurrent = $(galAreas).eq(e).find('.swiper-slide-active').attr('data-img-gal');
                $('.nav-type-gallery a').removeClass('actived');
                $('.nav-type-gallery a[data-gal=' + galTypeCurrent + ']').addClass('actived');

                //mobile change text
                /* const textDropMob = $('.nav-type-gallery a[data-gal='+galTypeCurrent+']').first().text(); 
                _parent.find('.dropdown-toggle').text('');
                _parent.find('.dropdown-toggle').text( textDropMob ); */


                if (imgZoom)
                    _parent.find('.js-load-img-zoom').attr('href', imgZoom);

                if (textDinamic)
                    _parent.find('.js-dinamic-text').html(textDinamic);

                if (titleDinamic)
                    _parent.find('.js-dinamic-title').html(titleDinamic);

            });

        })
    }

    const galleryLocation = () => {

        const galLoc = '.swiperLocalizacao';
        let _parent = $(galLoc).closest('.row-gallery');

        const swiperLoc = new Swiper(galLoc, {
            speed: 1500,
            loop:true,
            createElements: true,
            pagination: {
                el: ".swiper-pagination-loc",
                type: screen.width > 992 ? 'custom' : '',
                renderCustom: function (swiper, current, total) {
                    return '<span class="swiper-pagination-current-custom"> <strong class="me-1">' + current + ' </strong> </span> | ' + total;
                }
                //   clickable: true
            },
            navigation: {
                prevEl: '.swiper-button-prev-loc',
                nextEl: '.swiper-button-next-loc',
            },
        });
        swiperLoc.on('slideChangeTransitionEnd', function (sw) {
            let textDinamic = $(galLoc).find('.swiper-slide-active').find('picture').attr('data-to-text');

            if (textDinamic)
                _parent.find('.js-dinamic-text').html(textDinamic);


        });
    }
    
    const galleryDiferenciais = () => {

        const galLoc = '.swiperDiferenciais';
        let _parent = $(galLoc).closest('.row-gallery');

        const swiperLoc = new Swiper(galLoc, {
            speed: 1500,
            loop:true,
            createElements: true,
            pagination: {
                el: ".swiper-pagination-dif",
                type: screen.width > 992 ? 'custom' : '',
                renderCustom: function (swiper, current, total) {
                    return '<span class="swiper-pagination-current-custom"> <strong class="me-1">' + current + ' </strong> </span> | ' + total;
                }
                //   clickable: true
            },
            navigation: {
                prevEl: '.swiper-button-prev-dif',
                nextEl: '.swiper-button-next-dif',
            },
        });
        swiperLoc.on('slideChangeTransitionEnd', function (sw) {
            let textDinamic = $(galLoc).find('.swiper-slide-active').find('picture').attr('data-to-text');

            if (textDinamic)
                _parent.find('.js-dinamic-text').html(textDinamic);


        });
    }



    const galleryAptos = () => {

        const gaAptos = ".swiper-aptos";
        if ($(gaAptos).length <= 0) return;

        // for( let i=0; i< $(gaAptos).length; i++ ) {
        $(gaAptos).each(function (e) {

            let _parent = $(gaAptos).eq(e).closest('.row-gallery');

            $(gaAptos).eq(e).addClass('swiper-container-aptos-' + e);
            _parent.find('.swiper-button-prev').addClass('swiper-button-prev-aptos-' + e);
            _parent.find('.swiper-button-next').addClass('swiper-button-next-aptos-' + e);
            _parent.find('.swiper-pagination').addClass('swiper-pagination-aptos-' + e);

            if ($('.swiper-container-aptos-' + e).find('picture').length <= 1) {
                $('.swiper-container-aptos-' + e).closest('.row-gallery').find('.wrap-navigation-sw').hide();
            }

            const swiperaptos = new Swiper('.swiper-container-aptos-' + e, {
                // cssMode     : true,
                speed: 1500,
                loop: false,
                effect: 'slide',
                autoplay: false,
                pagination: {
                    el: '.swiper-pagination-aptos-' + e,
                    type: 'custom',
                    renderCustom: function (swiper, current, total) {
                        return '<span class="swiper-pagination-current-custom">' + current + '</span> | ' + total;
                    }
                    /* clickable: true,
                    renderBullet: function (aptos, className) {
                    return '<span class="' + className + '">' + (aptos + 1) + "</span>";
                    }, */
                },
                navigation: {
                    prevEl: '.swiper-button-prev-aptos-' + e,
                    nextEl: '.swiper-button-next-aptos-' + e,
                },
            });
            swiperaptos.on('slideChangeTransitionEnd', function (sw) {
                // console.log(swiperaptos.activeIndex, sw);
                let imgZoom = $(gaAptos).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-zoom');
                let textDinamic = $(gaAptos).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-to-text');
                let titleDinamic = $(gaAptos).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-to-title');
                let imgContent = $(gaAptos).eq(e).find('.swiper-slide-active').find('.img-content').html();
                let minimapa = $(gaAptos).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-minimapa');

                // ativa menu de nav
                const galTypeCurrent = $(gaAptos).eq(e).find('.swiper-slide-active').attr('data-img-gal');
                $('.nav-type-gallery a').removeClass('actived');
                $('.nav-type-gallery a[data-gal=' + galTypeCurrent + ']').addClass('actived');

                //mobile change text
                const textDropMob = $('.nav-type-gallery a[data-gal=' + galTypeCurrent + ']').first().text();
                _parent.find('.dropdown-toggle').text('');
                _parent.find('.dropdown-toggle').text(textDropMob);


                if (imgZoom)
                    _parent.find('.js-load-img-zoom').attr('href', imgZoom);

                if (textDinamic)
                    _parent.find('.js-dinamic-text').html(textDinamic);

                if (titleDinamic)
                    _parent.find('.js-dinamic-title').html(titleDinamic);
                
                if (imgContent)
                    _parent.find('.js-dinamic-content').html(imgContent);
                
                if (minimapa)
                    _parent.find('.js-dinamic-minimapa').attr('src',minimapa);

                

            });

            function getSlideIndexByClass(className) {
                var index = 0;
                $.each($(galaptos).find('.swiper-wrapper').children(), function (i, item) {
                    if ($(item).hasClass(className)) {
                        index = i;
                        return false;
                    }
                });
                return index;
            }

            //navigation
            $(document).on('click', '.nav-type-gallery a', function (e) {
                e.preventDefault();
                const _thisGalGo = $(this);
                const typeGallery = _thisGalGo.attr('data-gal');

                $('.nav-type-gallery a').removeClass('actived');
                _thisGalGo.addClass('actived');

                swiperaptos.slideTo(getSlideIndexByClass('data-img-gal--' + typeGallery));

            })

        })
    }

    const swiperNavGalPlanta = () => {
        const galNvPlant = '.swiperNavPlants';

        new Swiper(galNvPlant, {
            speed: 1500,
            loop:false,
            slidesPerView:3,
            spaceBetween : '5px',
            navigation: {
                prevEl: '#swiper-button-prev-plant',
                nextEl: '#swiper-button-next-plant',
            },
            breakpoints: {
                768: {
                    slidesPerView: 5,
                    spaceBetween: '10px',
                },
                992: {
                    slidesPerView: 7,
                    spaceBetween: '20px',
                }
            }
        });
    }

    const navPlantas = (e) => {
        
        const _this = e.currentTarget;
        let dataGal = $(_this).data('planta');

        $('.act-nav-plant').removeClass('actived');
        $('.wrap-gal-plants').removeClass('actived')
                
        $(_this).addClass('actived');
        $("#div-planta-"+dataGal).addClass('actived').show();
    }


    return {

        galleryAreas: galleryAreas,
        galleryLocation: galleryLocation,
        galleryDiferenciais: galleryDiferenciais,
        galleryAptos: galleryAptos,
        swiperNavGalPlanta: swiperNavGalPlanta,

        init : () => {
            $('.act-nav-plant').on('click', navPlantas);
        }

    }

}();

export default SwiperGalleries;